// @flow
import React from 'react';
import {
  AppInstallBannerContext,
  AppInstallBanner,
} from '../components/AppInstallBanner';
import { withTracking } from '../services/Tracking';
import {
  APP_INSTALL_BANNER_CLOSE,
  APP_INSTALL_BANNER_OPEN,
} from '../services/Tracking/TrackingEventTypes.constants';

type Props = {
  track: Function,
};

class AppInstallBannerContainer extends React.Component<Props> {
  handleCloseClick = (onCloseClick: Function) => (e: SyntheticMouseEvent<*>) => {
    const {
      track,
    } = this.props;

    if (track) {
      track(APP_INSTALL_BANNER_CLOSE);
    }

    if (onCloseClick) {
      onCloseClick(e);
    }
  }

  handleOpenClick = (onOpenClick: Function) => (e: SyntheticMouseEvent<*>) => {
    const {
      track,
    } = this.props;

    if (track) {
      track(APP_INSTALL_BANNER_OPEN);
    }

    if (onOpenClick) {
      onOpenClick(e);
    }
  }

  render() {
    return (
      <AppInstallBannerContext.Consumer>
        {({
          height,
          onCloseClick,
          onOpenClick,
          isVisible,
        }) => {
          if (!isVisible) {
            return null;
          }

          return (
            <AppInstallBanner
              height={height}
              onCloseClick={this.handleCloseClick(onCloseClick)}
              onOpenClick={this.handleOpenClick(onOpenClick)}
            />
          );
        }}
      </AppInstallBannerContext.Consumer>
    );
  }
}

export default withTracking(AppInstallBannerContainer);
